export default __webpack_public_path__ + "static/media/success_phase1.7fb370d4.png";